// extracted by mini-css-extract-plugin
export var brand = "_a0-9";
export var compact = "_a0-6";
export var extraSmall = "_a0-7";
export var icon = "_a0-0";
export var large = "_a0-4";
export var light = "_a0-1";
export var medium = "_a0-5";
export var outline = "_a0-b";
export var primaryDark = "_a0-a";
export var primaryLight = "_a0-8";
export var primaryModern = "_a0-c";
export var success = "_a0-2";
export var successSolid = "_a0-3";